import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { dashboardAPI as apiConfig } from '../../../axiosConfig';

const URL = 'payment-options-proxy?endpoint=paymentdashboard';

export const getCurrencies = createAsyncThunk(
  'currencies',
  async (_, { getState }) => {
    if (getState().paymentOptions.currencies.currencyList.length)
      return { details: getState().paymentOptions.currencies.currencyList };

    const url = `${URL}/currencies`;
    const response = await apiConfig.get(url).catch((error) => {
      console.error(JSON.stringify(error));
      return error && error.response;
    });

    response.data.details.sort((a, b) => a.id - b.id);

    return response.data;
  },
);

export const getCurrencyDetails = createAsyncThunk(
  'currencies/{currencyId}',
  async (currencyId) => {
    const url = `${URL}/currencies/${currencyId}`;
    const response = await apiConfig.get(url).catch((error) => {
      console.error(JSON.stringify(error));
      return error && error.response;
    });

    return response.data;
  },
);

export const updateCurrency = createAsyncThunk(
  'currencies/{currencyId}/update',
  async (payload) => {
    const url = `${URL}/currencies/${payload.id}`;
    const response = await apiConfig.put(url, payload).catch((error) => {
      console.error(JSON.stringify(error));
      return error && error.response;
    });

    return response.data;
  },
);

export const addNewCurrency = createAsyncThunk(
  'currencies/{currencyId}/addNew',
  async (payload) => {
    const url = `${URL}/currencies`;
    const response = await apiConfig.post(url, payload).catch((error) => {
      console.error(JSON.stringify(error));
      return error && error.response;
    });

    return response.data;
  },
);

const paymentOptionsCurrenciesSlice = createSlice({
  name: 'paymentOptionsCurrencies',
  initialState: {
    currencyList: [],
    selectedCurrency: {},
  },
  reducers: {
    resetCurrencies(state) {
      state.currencyList = [];
    },
    resetSelectedCurrency(state) {
      state.selectedCurrency = {};
    },
  },
  extraReducers: {
    [getCurrencies.fulfilled]: (state, action) => {
      if (!action.payload || !action.payload.details) {
        state.currencyList = [];
        return;
      }

      state.currencyList = action.payload.details;
    },
    [getCurrencyDetails.fulfilled]: (state, action) => {
      if (!action.payload || !action.payload.id) {
        state.selectedCurrency = {};
        return;
      }

      state.selectedCurrency = action.payload;
    },
  },
});

export const paymentOptionsCurrenciesActions =
  paymentOptionsCurrenciesSlice.actions;

export const selectCurrencies = (state) =>
  state.paymentOptions.currencies.currencyList;

export const selectSelectedCurrency = (state) =>
  state.paymentOptions.currencies.selectedCurrency;

export default paymentOptionsCurrenciesSlice.reducer;
